<template>
  <v-app id="inspire">
    <!-- <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
	  class="blue darken-4"
      dark
      app      
	  :mini-variant.sync="mini"
      permanent
    >
      <v-list dense>
        <template v-for="item in items">
          <v-row v-if="item.heading" :key="item.heading" align="center">
            <v-col cols="6">
              <v-subheader v-if="item.heading">{{ item.heading }}</v-subheader>
            </v-col>
            <v-col cols="6" class="text-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-col>
          </v-row>
          <v-list-group
            v-else-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title
                  @click="$router.push(`/AdmisionInscripcionInfo`);"
                >{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item v-for="(child, i) in item.children" :key="i" link>
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ child.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item v-else :key="item.text" link>
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer> -->

    <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="blue darken-4" dark>
      <v-app-bar-nav-icon @click.stop="mini = !mini" />
      <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
        <span>
          <img
            class="navbar-brand-logo"
            width="150"
            src="@/assets/images/logo-instituto.png"
            title="Sistema Académico"
            @click="$router.push(`/`);"
          />
        </span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
        <v-menu
            v-if="ssUser && ssMatConsejerias.length>0"
            v-model="dMenuConsejeria"
            :close-on-content-click="false"
            :nudge-width="200"
            offset-y
            >
            <template v-slot:activator="{ on, attrs }">
                <v-btn @click="$router.push(`/`)" icon dark v-bind="attrs" v-on="on">
                    <v-badge value="3" :content="ssMatConsejerias.length" color="red" overlap class="ma-3"><v-icon large>notifications</v-icon></v-badge>
                </v-btn>
            </template>
            <v-card>
                <v-list v-for="item in ssMatConsejerias" :key="item.IdConsejeria">
                    <v-list-item @click="$router.push(`/AlumnoItem/${item.IdAlumno}/Accion/2`); dMenuConsejeria=false">
                        <v-list-item-avatar>
                            <v-avatar color="primary">
                                <span class="white--text headline">{{item.prialumno.priservicio.Iniciales.substring(0,1).toUpperCase()}}</span>
                            </v-avatar>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title>{{item.prialumno.Alumno}}</v-list-item-title>
                            <v-list-item-subtitle>{{item.Detalle}}</v-list-item-subtitle>
                            <v-list-item-subtitle><v-icon title="Fecha Programado">access_alarm</v-icon> {{item.FechaProgramado}}</v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                        </v-list-item-action>
                    </v-list-item>
                    <v-divider></v-divider>
                </v-list>
            </v-card>
        </v-menu>
        <v-menu
            v-if="ssUser && ssCrmTicketCount>0"
            v-model="dMenuTicket"
            :close-on-content-click="false"
            :nudge-width="100"
            offset-y
            >
            <template v-slot:activator="{ on, attrs }">
                <v-btn  @click="$router.push(`/`)" icon dark v-bind="attrs" v-on="on">
                    <v-badge value="3" :content="ssCrmTicketCount" color="red" overlap class="ma-3"><v-icon large>receipt</v-icon></v-badge>
                </v-btn>
            </template>

            <v-card>
                <v-list v-for="item in ssCrmTickets" :key="item.crmticket.id">
                    <!-- <v-list-item @click="fuGoTo(item.crmticket.id_externo)"> -->
                    <v-list-item @click="$router.push(`/TicketItem/${item.crmticket.id}`); dMenuTicket=false">
                    <!-- <v-list-item @click="fuGoTo2(item.crmticket.id)"> -->
                        <template v-if="item.crmticket.crmcliente.id_tipo==1">
                            <v-list-item-avatar>
                                <v-avatar color="primary">
                                    <span class="white--text headline" :title="item.crmticket.crmcliente.prialumno.priservicio.Iniciales">{{item.crmticket.crmcliente.prialumno.priservicio.Iniciales.substring(0,1).toUpperCase()}}</span>
                                </v-avatar>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>{{item.crmticket.crmcliente.prialumno.Alumno}}</v-list-item-title>
                                <v-list-item-subtitle v-html="item.mensaje"></v-list-item-subtitle>
                                <v-list-item-subtitle><v-icon title="Fecha Asignado">access_alarm</v-icon> {{item.created_at}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </template>
                        <template v-else>
                            <v-list-item-avatar>
                                <!-- <v-avatar color="primary">
                                    <span class="white--text headline" :title="item.crmticket.crmcliente.admvisita.priservicio.Iniciales">{{item.crmticket.crmcliente.admvisita.priservicio.Iniciales.substring(0,1).toUpperCase()}}</span>
                                </v-avatar> -->
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>{{item.crmticket.crmcliente.admvisita.Visitante}}</v-list-item-title>
                                <v-list-item-subtitle v-html="item.mensaje"></v-list-item-subtitle>
                                <v-list-item-subtitle><v-icon title="Fecha Asignado">access_alarm</v-icon> {{item.created_at}}</v-list-item-subtitle>
                            </v-list-item-content>
                        </template>
                    </v-list-item>
                    <v-divider></v-divider>
                </v-list>
            </v-card>
        </v-menu>
        <v-menu
            v-if="ssUser"
            v-model="dMenuPerfil"
            :close-on-content-click="false"
            :nudge-width="200"
            offset-y
        >
            <template v-slot:activator="{ on, attrs }">
                <v-avatar color="accent" v-bind="attrs" v-on="on">
                    <span class="white--text headline">{{ssUser.Usuario.substring(0,2).toUpperCase()}}</span>
                </v-avatar>
            </template>
            <v-card>
                <v-list>
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title>{{ssUser.Personal}}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item v-if="ssUser.Usuario=='larenas' || ssUser.Usuario=='cquispeh'">
                        <v-list-item-content>
                            <v-list-item-title>
                                <v-dialog v-model="dCambiarUsuarioDialog" width="400">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn color="blue-grey" dark block v-bind="attrs" v-on="on">
                                             <v-icon>autorenew</v-icon> Cambiar Usuario
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-form ref="refCambiarUsuario">
                                            <v-card-text class="pa-10">
                                                <v-text-field v-model="dUser" label="Usuario" outlined :rules="[v => !!v || 'El campo es requerido']" :maxlength="20" autocomplete="off"></v-text-field>
                                            </v-card-text>
                                            <v-divider></v-divider>
                                            <v-card-actions class="blue-grey leighten-4">
                                                <v-btn @click.prevent="fuCambiarUsuario" :loading="dCambiarUsuarioLoading" color="blue-grey" dark><v-icon>autorenew</v-icon> Cambiar Usuario</v-btn>
                                                <v-spacer></v-spacer>
                                                <v-btn @click="dCambiarUsuarioDialog = false" color="grey"><v-icon>close</v-icon> Cerrar</v-btn>
                                            </v-card-actions>
                                        </v-form>
                                    </v-card>
                                </v-dialog>
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-btn color="error" block @click.prevent="saLogout"><v-icon>remove_circle</v-icon> Cerrar Sesión</v-btn>
                    </v-card-actions>
                </v-list>
            </v-card>
        </v-menu>
    </v-app-bar>
    <v-content class="blue lighten-5">
      <v-container fluid class="pa-0">
        <v-slide-y-transition mode="out-in">
          <router-view />
        </v-slide-y-transition>
      </v-container>
    </v-content>
    <v-footer color="grey lighten-1">
      <v-spacer></v-spacer>
      <div>Coorporación Khipu &copy;{{ new Date().getFullYear() }} v6.8.13</div>
    </v-footer>
  </v-app>
</template>

<script>
import gql from 'graphql-tag';
import {mapState, mapActions} from 'vuex';
import 'sweetalert2/src/sweetalert2.scss';
import Swal from 'sweetalert2/dist/sweetalert2.js';

export default {
    props: {
        source: String
    },
    data: () => ({
        drawer: null,
        mini: true,
        items: [{ icon: "home", text: "Inscripción" }],
        dMenuPerfil: false,
        dMenuConsejeria: false,
        dMenuTicket: false,
        dCambiarUsuarioDialog: false,
        dCambiarUsuarioLoading: false,
        dUser: null
    }),
    computed: {
        ...mapState(['ssUser', 'ssCrmTickets', 'ssCrmTicketCount', 'ssMatConsejerias']),
    },
    methods: {
        ...mapActions(['saLogin', 'saLogout', 'saCrmTickets', 'saCrmTicketCount', 'saMatConsejerias']),
        async fuMatconsejeriaEnProcesoByIdPersonal(){
            try {
                const response = await this.$apollo.query({
                    query: gql`query matconsejeriaEnProcesoByIdPersonal($IdPersonal: String, $Fecha: String){
                        matconsejeriaEnProcesoByIdPersonal(IdPersonal:$IdPersonal, Fecha: $Fecha){
                            IdConsejeria
                            Consejero
                            IdAlumno
                            Categoria
                            Detalle
                            Procedimiento
                            Fecha
                            FechaProgramado
                            Estado
                            prialumno{
                                Alumno
                                priservicio{
                                    Iniciales
                                }
                            }
                        }
                    }`,
                    variables: {
                        IdPersonal: this.ssUser.IdPersonal,
                        Fecha: new Date().toISOString()
                    }
                })
                this.saMatConsejerias(response.data.matconsejeriaEnProcesoByIdPersonal);
            } catch (error) {
                console.log(error);
            } finally {
            }
        },
        async fuCrmTickets(){
            try {
                const response = await this.$apollo.query({
                    query: gql`query consulta($id_operador_asignado: Int!, $token: String){
                        crmticketcomentarioByid_operador_asignadoByis_finalTop10(id_operador_asignado:$id_operador_asignado, is_final:0, token: $token){
                            id
                            mensaje
                            created_at
                            crmticket{
                                id
                                crmcliente{
                                    id_tipo
                                    prialumno{
                                        Alumno
                                        priservicio{
                                            Iniciales
                                        }
                                    }
                                    admvisita{
                                        Visitante
                                        priservicio{
                                            Iniciales
                                        }
                                    }
                                }
                            }
                        }
                        crmticketcomentarioByid_operador_asignadoByis_finalCount(id_operador_asignado:$id_operador_asignado, is_final:0, token: $token){
                            data
                        }
                    }`,
                    variables: {
                        id_operador_asignado: this.ssUser.IdPersonal,
                        token: new Date().toISOString()
                    }
                })
                this.saCrmTickets(response.data.crmticketcomentarioByid_operador_asignadoByis_finalTop10);
                this.saCrmTicketCount(response.data.crmticketcomentarioByid_operador_asignadoByis_finalCount.data);
                console.log("desde mainloguot");
                
            } catch (error) {
                console.log(error);
            } finally {
            }
        },
        async fuCambiarUsuario(){
            if(this.$refs.refCambiarUsuario.validate()){
                try {
                    this.dCambiarUsuarioLoading = true;
                    const response = await this.$apollo.query({
                        query: gql`query pripersonalByUsuario($Usuario: String!){
                            pripersonalByUsuario(Usuario:$Usuario){
                                IdPersonal
                                Usuario
                                Personal
                                IdKhipuPlus
                            }
                        }`,
                        variables: {
                            Usuario: this.dUser
                        }
                    })
                    if(!response.data.pripersonalByUsuario){
                        Swal.fire('¡ ERROR !', 'No existe usuario.', 'error');
                        this.saLogout();
                    } else {
                        localStorage.setItem('kpUser', JSON.stringify(response.data.pripersonalByUsuario));
                        this.saLogin(response.data.pripersonalByUsuario);
                        this.fuMatconsejeriaEnProcesoByIdPersonal();
                        this.fuCrmTickets();
                    }
                } catch (error) {
                    console.log(error);
                    Swal.fire('¡ ERROR !', 'Error en la conexión.', 'error');
                    this.saLogout();
                } finally {
                    this.dCambiarUsuarioDialog = false;
                    this.dCambiarUsuarioLoading = false;
                }
            }
        },
        fuGoTo(pid_externo){
            this.dMenuTicket=false;
            window.location = 'https://khipu.plus/crm/ticket/'+pid_externo;
        },
        // fuGoTo2(pid){
        //     this.dMenuTicket=false;
        //     this.$router.push(`/Ticket/${pid}`);

            // this.$router.push({name:'Ticket',params:{pid:pid}});

            // this.$router.replace(`/Ticket/${pid}`);
            // window.location = 'http://localhost:8080/#/Ticket/'+pid;

            //this.$router.push({ path: '/Ticket', params: { pid: '1796' } })
            // this.$router.push({ path: `/Ticket/${pid}` })
        // }
    }
}
</script>
